import { all, put, spawn } from 'redux-saga/effects'
import { startChatAction } from '../../actions'
import { refreshChatsCountAction } from '../../handles'
import { Chat } from '../../types'
import { handleChangesWhenChatIsOpenAtFirst, updateOperator, updateOperatorsId } from './helpers'
import { onStartServiceHook } from './http/onStartServiceHook'
import { ChatModel } from '@/models/chat.model'
import { Operator } from '@/models/message.model'
import { update } from '../_http/chat'

export function* startChatSaga(action: ReturnType<typeof startChatAction.request>) {
  const { activeChat, currentOperator, companyId } = action.payload
  try {
    updateChatDurationsOnStart(activeChat, currentOperator)
    const updatedData: Partial<Chat> = {
      status: 'in_progress',
      startDate: activeChat?.startDate ? activeChat?.startDate : new Date().getTime(),
      operators: updateOperator(activeChat.operators, currentOperator),
      operatorsId: updateOperatorsId(activeChat.operatorsId, currentOperator?.id),
      durations: activeChat?.durations,
      isTransfered: false
    }
    yield put(startChatAction.success({ updatedChatData: updatedData }))
    yield all([
      update(activeChat.id, updatedData),
      handleChangesWhenChatIsOpenAtFirst({ ...activeChat, ...updatedData }, currentOperator?.id)
    ])
    yield put(refreshChatsCountAction())

    yield spawn(onStartServiceHook, { currentChat: { ...activeChat, ...updatedData }, companyId })
  } catch (error) {
    console.error('Error when starting chat:', error)
    yield put(startChatAction.failure(error))
  }
}

function updateChatDurationsOnStart(activeChat: ChatModel, currentOperator: Operator) {
  const operatorDuration = findOperatorDuration(activeChat, currentOperator)
  if (operatorDuration?.operatorId) {
    operatorDuration.periods.push({ startTime: Date.now() })
  } else {
    activeChat.durations = activeChat?.durations ?? []
    activeChat.durations.push({ operatorId: currentOperator?.id, periods: [{ startTime: Date.now() }] })
  }
}

function findOperatorDuration(activeChat: ChatModel, currentOperator: Operator) {
  const durations = activeChat?.durations ?? []
  const operatorDuration = durations.find(duration => duration.operatorId === currentOperator?.id)
  return operatorDuration
}
